var _defs, _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect, _rect2, _path8, _path9, _polygon, _rect3, _path10, _path11, _path12, _path13, _circle, _circle2, _path14, _path15, _path16, _path17, _ellipse2, _path18, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 323.86 291.24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 213.74,
    y1: 162.74,
    x2: 152.21,
    y2: 191.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 207.89,
    y1: 100.72,
    x2: 122.88,
    y2: 96.49,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 131.65,
    y1: 93.23,
    x2: 166.75,
    y2: 140.38,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 218.93,
    y1: 135.63,
    x2: 140.91,
    y2: 138.81,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 121.26,
    y1: 112.25,
    x2: 196.75,
    y2: 159.51,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 205.13,
    y1: 85.58,
    x2: 134.46,
    y2: 118.6,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 144.59,
    y1: 140.66,
    x2: 192.17,
    y2: 132.41,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 147.81,
    y1: 182.74,
    x2: 245.9,
    y2: 165.73,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 210.05,
    y1: 258.91,
    x2: 218.89,
    y2: -12.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#fff",
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#fff",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#fff",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#fff",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#fff",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#fff",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#fff",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#fff",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M364,239c-1.45,15.09-13.53,27-26.26,35.22-8,5.19-16.75,9.55-26.1,11.56-13.18,2.82-26.86.84-40.33,1.38-32.88,1.32-64.19,17.63-97.07,16.31-22.15-.9-43.28-9.82-62.26-21.27-8.07-4.87-16.18-10.57-20.49-19-2.71-5.28-3.72-11.27-6.07-16.72-9.08-21-36.17-30.48-43.33-52.2-4.33-13.13-.13-27.49,5.24-40.23,5.72-13.6,13-26.93,24.21-36.55a88.18,88.18,0,0,1,10.19-7.42c10.56-6.78,22-12.43,29.67-22.25,9.06-11.6,11.26-27.06,18-40.17C141.7,23.59,170.62,9.25,197.24,14c6.62,1.18,13.41-1.48,20.13-1.75a525.28,525.28,0,0,1,72.74,5.26c19.19,2.73,40.38,7.93,50.73,24.31,5.7,9,7.09,20.06,7.63,30.72a238.86,238.86,0,0,1-5.27,63.21c-.33,1.53-.68,3.06-1,4.59-2.6,11.26-5.35,22.71-3.33,34C343,197.43,366.24,215.63,364,239Z",
    transform: "translate(-40.3 -12.27)",
    fill: "#3cbdea",
    opacity: 0.18,
    style: {
      isolation: "isolate"
    }
  }), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 169.67,
    cy: 248.4,
    rx: 85.73,
    ry: 24.77,
    fill: "#282328",
    opacity: 0.16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M197.59,199.5h-4.34a21.61,21.61,0,0,1-21.62-21.61V153.21h31.88Z",
    transform: "translate(-40.3 -12.27)",
    fill: "#3cbdea"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M203.52,153.21l-5.93,46.29h-4.34a21.61,21.61,0,0,1-21.61-21.62V153.21Z",
    transform: "translate(-40.3 -12.27)",
    fill: "url(#linear-gradient)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M149.3,69.84h29.53a0,0,0,0,1,0,0v35.45a0,0,0,0,1,0,0H120.71a0,0,0,0,1,0,0V98.43A28.59,28.59,0,0,1,149.3,69.84Z",
    fill: "#3cbdea"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M219.13,82.11v35.45H161V110.7A28.59,28.59,0,0,1,189.6,82.11Z",
    transform: "translate(-40.3 -12.27)",
    fill: "url(#linear-gradient-2)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M238.13,136.23s5.73-6.85,10.91-4.4-2.59,14.64-3,18.92-5.65,10.2-9.67,8S238.13,136.23,238.13,136.23Z",
    transform: "translate(-40.3 -12.27)",
    fill: "#ffbbab"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M240.28,120.34s-1.16,61.17-15.09,71.43-27.6,7.73-27.6,7.73V102S234.42,100.8,240.28,120.34Z",
    transform: "translate(-40.3 -12.27)",
    fill: "#ffbbab"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M244.5,89.89c-1-.1-1.81,1-1.83,2a6.43,6.43,0,0,0,1,2.87c2.58,5.29,3.31,11.24,3.14,17.06-.16,5.38-1.91,11-1.43,16.32.13,1.49.43,3.09-.28,4.41a9,9,0,0,1-2.14,2.21c-2.85,2.57-4.17,6.39-5.38,10-.42-2.69.09-5.43.47-8.12s.64-5.41.76-8.12c.07-1.52.91-6.42,0-7.62-1.1-1.48-3.52.36-5.12.9-.54.18-6.6,1.72-6.62,1.55l-.58-8.35-15.36,3.35c.09-1.71,0-3.83-1.59-4.56a4.37,4.37,0,0,0-2.68,0l-9.44,1.83c1.08-3.18-1.51-8.69-1.75-12-.45-6.18,1.57-10.31,1.49-16.5,0-3.29-1.67-13.61,1.76-15.32S210.6,73,214.06,73.9a76.82,76.82,0,0,1,15.23,5.79A75.2,75.2,0,0,1,244.5,89.89Z",
    transform: "translate(-40.3 -12.27)",
    fill: "#42202e"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 129.38,
    y: 104.17,
    width: 27.91,
    height: 9.53,
    fill: "#3cbdea"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 129.38,
    y: 104.17,
    width: 27.91,
    height: 9.53,
    fill: "url(#linear-gradient-3)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M122.88,108.93h34.41a0,0,0,0,1,0,0v32a0,0,0,0,1,0,0H122.88a5.47,5.47,0,0,1-5.47-5.47V114.4A5.47,5.47,0,0,1,122.88,108.93Z",
    fill: "#3cbdea"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M197.59,121.2v32H163.18a5.47,5.47,0,0,1-5.47-5.48V126.67a5.47,5.47,0,0,1,5.47-5.47Z",
    transform: "translate(-40.3 -12.27)",
    fill: "url(#linear-gradient-4)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "157.45 151.48 151.95 151.48 155.96 132.51 157.45 132.51 157.45 151.48",
    fill: "#3cbdea"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 144.77,
    y: 154.74,
    width: 12.52,
    height: 17.84,
    fill: "#3cbdea"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M210,143.3a5.12,5.12,0,0,0,3,1.06,57.2,57.2,0,0,0,12.27.17",
    transform: "translate(-40.3 -12.27)",
    fill: "none",
    stroke: "#42202e",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M230.79,130.71c-2.86.38-5.72.82-8.56,1.34a30.93,30.93,0,0,0-6.71,1.8c-1.32.57-4.15,2.84-5.61,2.27s-.55-2.49.46-3c1.77-1,4.28-1.23,6.23-1.6a56.39,56.39,0,0,1,6.6-.82A53.4,53.4,0,0,1,230.79,130.71Z",
    transform: "translate(-40.3 -12.27)",
    fill: "#42202e"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M197.59,177.28A57.77,57.77,0,0,0,209,175.83",
    transform: "translate(-40.3 -12.27)",
    fill: "none",
    stroke: "#42202e",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M202,154.25l.55,3.73a5.59,5.59,0,0,1,0,2.23,4,4,0,0,1-1.22,1.86,6.63,6.63,0,0,1-3.57,1.68",
    transform: "translate(-40.3 -12.27)",
    fill: "none",
    stroke: "#42202e",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 142.5,
    cy: 125.55,
    r: 7.26,
    fill: "url(#linear-gradient-5)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 142.5,
    cy: 125.55,
    r: 4.43,
    fill: "#3cbdea"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M196.89,82.11v1.26C167,83.7,166,117.56,166,117.56h-5V110.7A28.59,28.59,0,0,1,189.6,82.11Z",
    transform: "translate(-40.3 -12.27)",
    fill: "url(#linear-gradient-6)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M166.34,121.2v32h-3.16a5.47,5.47,0,0,1-5.47-5.48V126.67a5.47,5.47,0,0,1,5.47-5.47Z",
    transform: "translate(-40.3 -12.27)",
    fill: "url(#linear-gradient-7)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M197.59,194.34v5.16h-4.34a21.61,21.61,0,0,1-21.61-21.62V153.21h22.84l-.51,2.43H175.54s-2.84,33.17,8.1,36S197.59,194.34,197.59,194.34Z",
    transform: "translate(-40.3 -12.27)",
    fill: "url(#linear-gradient-8)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M243.77,137.79a2.51,2.51,0,0,1,2.14-1,1.89,1.89,0,0,1,1.37,1.35,4.64,4.64,0,0,1,.07,2,37.16,37.16,0,0,1-2.76,9c-1.08,2.65-2.24,5.43-4.5,7.19-.86.66-2.08,1.15-3,.56-2.76-1.8-1.06-7.41.76-9.26,1.31-1.32,2.56-1.91,3.27-3.72C242,141.66,242.05,139.65,243.77,137.79Z",
    transform: "translate(-40.3 -12.27)",
    fill: "#e0a194"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 169.67,
    cy: 235.78,
    rx: 77.07,
    ry: 18.18,
    fill: "#3cbdea"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M343.2,135.77c-.33,1.53-.68,3.06-1,4.59L289.78,248.51a18.33,18.33,0,0,1-10.2,9.24c-20.94,7.67-84.63,26.87-140.06.79A18.3,18.3,0,0,1,130.06,248L81.73,110.08c10.56-6.78,22-12.43,29.67-22.25,9.06-11.6,11.26-27.06,18-40.17C141.7,23.59,170.62,9.25,197.24,14c6.62,1.18,13.41-1.48,20.13-1.75a525.28,525.28,0,0,1,72.74,5.26c19.19,2.73,40.38,7.93,50.73,24.31,5.7,9,7.09,20.06,7.63,30.72A238.86,238.86,0,0,1,343.2,135.77Z",
    transform: "translate(-40.3 -12.27)",
    fill: "url(#linear-gradient-9)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M329.66,89.37a12.63,12.63,0,0,1-24.55,4.2,12.48,12.48,0,0,1-.72-4.2,12.64,12.64,0,0,1,25.27,0Z",
    transform: "translate(-40.3 -12.27)",
    fill: "#3cbdea",
    opacity: 0.82,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.85,83.89a12.63,12.63,0,0,1-20.74,9.68,12.48,12.48,0,0,1-.72-4.2,12.64,12.64,0,0,1,20.74-9.69A12.49,12.49,0,0,1,325.85,83.89Z",
    transform: "translate(-40.3 -12.27)",
    fill: "#fff",
    opacity: 0.55,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298,106.15a6.31,6.31,0,0,1-12.27,2.1,6.14,6.14,0,0,1-.36-2.1,6.32,6.32,0,1,1,12.63,0Z",
    transform: "translate(-40.3 -12.27)",
    fill: "#3cbdea",
    opacity: 0.82,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.12,103.41a6.32,6.32,0,0,1-10.37,4.84,6.14,6.14,0,0,1-.36-2.1,6.32,6.32,0,0,1,10.37-4.85A6.4,6.4,0,0,1,296.12,103.41Z",
    transform: "translate(-40.3 -12.27)",
    fill: "#fff",
    opacity: 0.55,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.74,49.52a9.06,9.06,0,1,1-3.25-7A9.06,9.06,0,0,1,178.74,49.52Z",
    transform: "translate(-40.3 -12.27)",
    fill: "#3cbdea",
    opacity: 0.82,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176,45.59a9.06,9.06,0,0,1-14.87,6.94,9.07,9.07,0,0,1,8.55-12.07,9,9,0,0,1,5.81,2.11A8.87,8.87,0,0,1,176,45.59Z",
    transform: "translate(-40.3 -12.27)",
    fill: "#fff",
    opacity: 0.55,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.53,163.75a6.5,6.5,0,1,1-6.49-6.5,6.51,6.51,0,0,1,6.49,6.5Z",
    transform: "translate(-40.3 -12.27)",
    fill: "#3cbdea",
    opacity: 0.82,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.57,160.93a6.5,6.5,0,0,1-10.66,5,6.5,6.5,0,0,1,6.13-8.66,6.4,6.4,0,0,1,4.16,1.52A6.17,6.17,0,0,1,291.57,160.93Z",
    transform: "translate(-40.3 -12.27)",
    fill: "#fff",
    opacity: 0.55,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.85,167.32a9.05,9.05,0,0,1-17.6,3,8.81,8.81,0,0,1-.52-3,9.06,9.06,0,0,1,18.12,0Z",
    transform: "translate(-40.3 -12.27)",
    fill: "#3cbdea",
    opacity: 0.82,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.12,163.39a9.05,9.05,0,0,1-9.06,9.06,9,9,0,0,1-5.81-2.12,8.81,8.81,0,0,1-.52-3,9.07,9.07,0,0,1,14.87-6.95A8.91,8.91,0,0,1,97.12,163.39Z",
    transform: "translate(-40.3 -12.27)",
    fill: "#fff",
    opacity: 0.55,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.42,137.91a4.53,4.53,0,0,1-8.8,1.51,4.48,4.48,0,0,1-.26-1.51,4.53,4.53,0,0,1,9.06,0Z",
    transform: "translate(-40.3 -12.27)",
    fill: "#3cbdea",
    opacity: 0.82,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.06,136a4.54,4.54,0,0,1-7.44,3.47,4.48,4.48,0,0,1-.26-1.51,4.53,4.53,0,0,1,7.44-3.47A4.44,4.44,0,0,1,88.06,136Z",
    transform: "translate(-40.3 -12.27)",
    fill: "#fff",
    opacity: 0.55,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.5,118.4a4.53,4.53,0,0,1-8.8,1.51,4.44,4.44,0,0,1-.26-1.51,4.53,4.53,0,0,1,4.53-4.52,4.53,4.53,0,0,1,4.53,4.52Z",
    transform: "translate(-40.3 -12.27)",
    fill: "#3cbdea",
    opacity: 0.82,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.13,116.44a4.52,4.52,0,0,1-7.43,3.47,4.44,4.44,0,0,1-.26-1.51,4.53,4.53,0,0,1,4.53-4.52,4.46,4.46,0,0,1,2.9,1.05A4.44,4.44,0,0,1,129.13,116.44Z",
    transform: "translate(-40.3 -12.27)",
    fill: "#fff",
    opacity: 0.55,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.82,
    style: {
      isolation: "isolate"
    }
  }, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "58.83 152.31 57.88 151.97 67.09 126.11 48.18 125.16 48.23 124.16 68.49 125.18 58.83 152.31",
    fill: "#3cbdea"
  }))), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "80.94 126.14 67.79 126.14 67.79 125.14 80.17 125.14 84.51 108.8 85.48 109.06 80.94 126.14",
    fill: "#3cbdea"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M263.9,219.6a2.86,2.86,0,0,1,4,4,2.63,2.63,0,0,1-.69.68,2.86,2.86,0,0,1-3.26-4.7Z",
    transform: "translate(-40.3 -12.27)",
    fill: "#3cbdea",
    opacity: 0.82,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.38,221a2.86,2.86,0,0,1,4.47,2.61,2.63,2.63,0,0,1-.69.68,2.85,2.85,0,0,1-4.47-2.61A2.63,2.63,0,0,1,263.38,221Z",
    transform: "translate(-40.3 -12.27)",
    fill: "#fff",
    opacity: 0.55,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.88,198.57a2.85,2.85,0,0,1,3.94,4,2.63,2.63,0,0,1-.69.68,2.86,2.86,0,0,1-3.25-4.7Z",
    transform: "translate(-40.3 -12.27)",
    fill: "#3cbdea",
    opacity: 0.82,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.35,200a2.86,2.86,0,0,1,4,.71,2.9,2.9,0,0,1,.49,1.89,2.63,2.63,0,0,1-.69.68,2.86,2.86,0,0,1-4.47-2.61A2.59,2.59,0,0,1,261.35,200Z",
    transform: "translate(-40.3 -12.27)",
    fill: "#fff",
    opacity: 0.55,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.82,
    style: {
      isolation: "isolate"
    }
  }, _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "227.06 208.91 226.73 207.97 245.55 201.16 238.98 190.6 256.77 185.79 257.03 186.75 240.54 191.21 247.05 201.68 227.06 208.91",
    fill: "#3cbdea"
  }))), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "239.35 191.19 234.98 184.89 225.07 188.47 224.73 187.52 235.36 183.69 240.17 190.62 239.35 191.19",
    fill: "#3cbdea"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M297.74,192.76a5.74,5.74,0,1,1-2.43,4.19A5.72,5.72,0,0,1,297.74,192.76Z",
    transform: "translate(-40.3 -12.27)",
    fill: "#3cbdea",
    opacity: 0.82,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.69,195.59a5.72,5.72,0,0,1,8.95,5.22A5.72,5.72,0,0,1,295.31,197,5.58,5.58,0,0,1,296.69,195.59Z",
    transform: "translate(-40.3 -12.27)",
    fill: "#fff",
    opacity: 0.55,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.82,
    style: {
      isolation: "isolate"
    }
  }, _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "249.33 188.45 237.37 167.92 250.71 162.2 247.38 156.13 248.25 155.65 252.11 162.69 238.81 168.39 250.2 187.95 249.33 188.45",
    fill: "#3cbdea"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M294.61,67A6.49,6.49,0,0,1,282,69.15a6.4,6.4,0,0,1-.37-2.16,6.5,6.5,0,0,1,13,0Z",
    transform: "translate(-40.3 -12.27)",
    fill: "#3cbdea",
    opacity: 0.82,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.65,64.18a6.48,6.48,0,0,1-6.49,6.49A6.37,6.37,0,0,1,282,69.15a6.4,6.4,0,0,1-.37-2.16,6.5,6.5,0,0,1,10.66-5A6.51,6.51,0,0,1,292.65,64.18Z",
    transform: "translate(-40.3 -12.27)",
    fill: "#fff",
    opacity: 0.55,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.82,
    style: {
      isolation: "isolate"
    }
  }, _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "250.41 91.7 238.45 71.16 251.79 65.45 248.46 59.38 249.33 58.9 253.19 65.93 239.88 71.64 251.27 91.2 250.41 91.7",
    fill: "#3cbdea"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAi);
export default __webpack_public_path__ + "static/media/AI.afa3b5ba068f1e999b309ec99c335349.svg";
export { ForwardRef as ReactComponent };